import React from 'react';
import { Box, CardMedia, Divider, Stack, Typography } from '@mui/material';
import FocusInspectionButtonWeb from './FocusInspectionButtonWeb';

const Backed12YearWeb = () => (
  <>
    <Stack sx={{ py: 11, px: '100px', backgroundColor: 'white' }}>
      <Stack textAlign="center" alignItems="center">
        <Typography fontSize={46} fontWeight={700} color="#121212">
          Backed by{' '}
          <Box component="span" color="#FE5302">
            12 Years
          </Box>{' '}
          of Happy Drives
        </Typography>
        <Box py={5} sx={{ textAlign: 'left', width: 'fit-content' }}>
          <Typography fontSize={23} fontWeight={600} color="#121212">
            For over 12 years, FOCUS Motors has
          </Typography>
          <Typography fontSize={23} fontWeight={600} color="#121212">
            been the trusted name in quality car
          </Typography>
          <Typography fontSize={23} fontWeight={400} color="#121212">
            inspections and customer satisfaction.
          </Typography>
        </Box>
      </Stack>
      <CardMedia
        component="img"
        className=""
        src="assets/images/Inspection/12Web.webp"
        alt="Card Image"
        // height={isMobile ? 25 : 40}
        sx={{ objectFit: 'contain', borderRadius: '10px' }}
      />
      <Stack flexDirection="row" alignContent={'center'} justifyContent="center" gap={10} sx={{ py: 6 }}>
        <Stack gap={1}>
          <Typography color="#000000" fontWeight={400} fontSize="19px">
            🚗 12+ years of automotive expertise
          </Typography>
          <Typography color="#000000" fontWeight={400} fontSize="19px">
            🌟 Thousands of happy customers
          </Typography>
          <Typography color="#000000" fontWeight={400} fontSize="19px">
            🛠️ Trusted for reliable, in-depth inspections
          </Typography>
        </Stack>
        <Divider orientation="vertical" flexItem sx={{ borderColor: '#33333333', my: 2 }} />

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <FocusInspectionButtonWeb
            title="Book  Your Inspection Now"
            subTitleColor="#121212"
            subtitle="Inspection team will contact you soon."
            // onClick={() => console.log('Button clicked')}
          />
        </Box>
      </Stack>
    </Stack>
  </>
);

export default Backed12YearWeb;
